import React, { useEffect, useState } from "react";
import LeftSideNavigation from "../../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../../../navigationSection/TopNavigationBarMobile";
import { Container, Col, Form, Row, Image, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useFormik } from "formik";
import moment from "moment";
import { useSelector } from "react-redux";
import Alert from "react-s-alert";
import GuestData from "./GuestData";
import { amApi } from "../../../../../api/apiHelper";
import { errorAlert, successAlert } from "../../../../../function/alert";
import { isEmpty } from "lodash";
import GuestForm from "./GuestForm";
import PaymentExperience from "./PaymentExp";

const EditExperienceGuest = ({ ...props }) => {
    const history = useHistory();
    const exp = history?.location?.state;
    const reqId = history?.location?.pathname?.split('/')[3];
    // const [path, setPath] = useState("ADD");

    const [expRequest, setExpRequest] = useState({});
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [reservationSlots, setReservationSlots] = useState([]);




    const formik = useFormik({
        initialValues: GuestData.initialValues,
        validationSchema: GuestData.validation
    });

    // const paymentPage = () => {
    //     if(isEmpty(formik.errors)){
    //         setPath('PAYMENT');
    //     }else {
    //         Alert.error(`<h4>Please fill the  required fields</h4>`, {
    //             position: "top-right",
    //             effect: "bouncyflip",
    //             beep: true,
    //             html: true,
    //             timeout: 3000,
    //             offset: 35,
    //           });
    //         }  
    // }

    const onCancel = () => {
        history.goBack()
    }

    // useEffect(() => {
    //     if (vendor?.country_code) formik.setFieldValue('userDetails.countryCode', vendor?.country_code);
    // }, [vendor])
    const fetchData = async () => {
        let expReq = await amApi.get(`/expRequest/${reqId}`);
        if (expReq?.data) {
            setExpRequest(expReq.data);
        }

        formik.setValues({
            userDetails: expReq?.data?.userDetails,
            experienceId: expReq?.data?.experienceId._id,
            adultCount: expReq?.data?.adultCount,
            adultPrice: expReq?.data?.adultPrice,
            adultPriceChanged: expReq?.data?.adultPriceChanged,
            occasion: expReq?.data?.occasion,
            kidCount: expReq?.data?.kidCount,
            kidPrice: expReq?.data?.kidPrice,
            kidPriceChanged: expReq?.data?.kidPriceChanged,
            package: expReq?.data?.package,
            userId: expReq?.data?.userId,
            highchairAccess: expReq?.data?.highchairAccess,
            highchairCount: expReq?.data?.highchairCount,
            handicapCount: expReq?.data?.handicapCount,
            seatingPreference: expReq?.data?.seatingPreference,
            reservationDate: moment(expReq?.data?.reservationTime).format('YYYY-MM-DD'), reservationTime: moment(expReq?.data?.reservationTime).format('LT')
        })
    }

    useEffect(() => {
        if (reqId) {
            fetchData();
        }
    }, [reqId]);

    useEffect(() => {
        async function fetchData() {
            let response = await amApi(`/user-check?mobile_number=${formik.values?.userDetails?.mobileNumber}&country_code=${formik.values?.userDetails?.countryCode}`);
            if (response.status === 200 && !isEmpty(response.data)) {
                let userDetails = { name: `${response.data?.first_name} ${response.data?.last_name}`, email: response.data?.email, fcmToken: response.data.FCMtoken || "", mobileNumber: response.data.mobile_number, countryCode: response.data.country_code }
                formik.setFieldValue('userDetails', userDetails);
                formik.setFieldValue('userId', response.data._id);
            }
        }
        if (/^[6-9]{1}[0-9]{9}$/.test(formik.values?.userDetails?.mobileNumber)) {
            fetchData()
        }
    }, [formik.values?.userDetails?.mobileNumber])


    useEffect(() => {
        async function fetchData() {
            let response = await amApi(`/restaurant-availability`, { params: { id: expRequest?.experienceId.restaurantId, date: formik?.values?.reservationDate, expId: expRequest?.experienceId?._id } });
            setReservationSlots(response.data)
        }
        if (!isEmpty(expRequest.experienceId?._id) && formik.values?.reservationDate) {
            fetchData()
        }
    }, [formik.values?.reservationDate]);

    const onEditSave = async () => {
        setBtnDisabled(true);
        await amApi.patch(`/expRequest/${expRequest._id}`, formik.values);
        setBtnDisabled(false);
        successAlert('Updated Successfully');
        history.goBack();
    }

    // if (props?.location?.state?.expType === "SPECIAL")


    return (
        <React.Fragment>
            <Container fluid>
                <Row>
                    <div className="left-side-panel">
                        <LeftSideNavigation />
                    </div>
                    <div className="top-panel">
                        <TopNavigationBarMobile displayLeft="logo" />
                    </div>
                    <div className="right-side-panel">
                        <RightSideNavigation
                            history={history}
                            leftText={"history"}
                            displayText={'Back'}
                            noEnAdminPic={true} />
                        <GuestForm experience={expRequest.experienceId} paymentPage={onEditSave}  formik={formik} onCancel={onCancel} reservationSlots={reservationSlots} btnDisabled={btnDisabled} edit ={true}/> :
                    </div>
                </Row>
            </Container>
        </React.Fragment >
    );
};

export default EditExperienceGuest;